import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { formatNumber } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { UtilidadGeneraTabla } from '../../shared/utilities/utilidad-genera-tabla';
import { Constantes } from '../../shared/constant/constantes';
import { MenuEstadistica } from '../../shared/entities/menu-estadistica';
import { TablaCatalogoDatos } from '../../shared/entities/tabla-catalogo-datos';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { DomSanitizer, Meta, SafeHtml, SafeResourceUrl, Title } from '@angular/platform-browser';
import { UtilidadDashboard } from '../../shared/utilities/utilidad-dashboard';
import * as Highcharts from 'highcharts';
import more from 'highcharts/highcharts-more';
import { SeriesOptionsType } from 'highcharts';
import boost from 'highcharts/modules/boost';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { HeaderComponent } from '../../shared/header/header.component';
import { MenuAlternoComponent } from '../public/menu-alterno/menu-alterno.component';
import { MenuMasConsultadosComponent } from '../public/menu-mas-consultados/menu-mas-consultados.component';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { HighchartsChartModule, } from 'highcharts-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { environment } from '../../../../environments/environment.development';

interface ArbolDashboard {
  nombre: string;
  selected: boolean;
  estilo: string;
  url: string;
  hijos?: ArbolDashboard[];
  idDashboard?: number
}

interface InfoTile {
  nombre: string;
  fecha: string;
  unidad: string;
  valor: string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  standalone: true,
  imports: [HeaderComponent, MenuAlternoComponent, MenuMasConsultadosComponent, CdkAccordionModule, HighchartsChartModule, MatIconModule, MatTreeModule, CommonModule]
})
export class DashboardComponent implements OnInit {

  @ViewChildren(CdkAccordionItem) accordionItem!: QueryList<CdkAccordionItem>;

  private utilidadTabla: UtilidadGeneraTabla = new UtilidadGeneraTabla();
  private utilidadDashboard: UtilidadDashboard = new UtilidadDashboard();
  public constantes: Constantes = new Constantes();

  public listaCatalogo: Array<MenuEstadistica> = new Array();
  public listaTablaCatalogo: Array<TablaCatalogoDatos> = new Array();

  public mapaArbol: Map<string, ArbolDashboard[]> = new Map();

  public urlSafe!: SafeResourceUrl;
  public externalContent: SafeHtml = '';

  public selectedIndex: number = 0;

  public menuWeb: any;

  public oracleReportDV: string = environment.URL_ORACLE_REPORT_DV;
  public oracleDashboardDV: string = '';
  public oracleJavascript: string = '';
  public oracleToken: string = '';

  //ARBOL
  public treeControl = new NestedTreeControl<ArbolDashboard>(node => node.hijos);
  public dataSource = new MatTreeNestedDataSource<ArbolDashboard>();

  public listaTile: Array<InfoTile> = new Array();

  public constante: Constantes = new Constantes();

  /************************Highcharts**************************** */

  public HighchartsMetaInflacion: typeof Highcharts = Highcharts;
  public HighchartsInflacionAnual: typeof Highcharts = Highcharts;

  public HighchartsTPM: typeof Highcharts = Highcharts;
  public HighchartsOMA: typeof Highcharts = Highcharts;

  public HighchartsTRM: typeof Highcharts = Highcharts;
  public HighchartsSalario: typeof Highcharts = Highcharts;

  public updateFlag = false;

  public chartOptionsMetaInflacion: Highcharts.Options = this.utilidadDashboard.initChartGenerico(1, 'line');
  public chartOptionsTPM: Highcharts.Options = this.utilidadDashboard.initChartGenerico(1, 'line');
  public chartOptionsOMA: Highcharts.Options = this.utilidadDashboard.initChartMoneda();
  public chartOptionsTRM: Highcharts.Options = this.utilidadDashboard.initChartGenerico(1, 'line');
  public chartOptionsSalario: Highcharts.Options = this.utilidadDashboard.initChartGenerico(1, 'line');

  public cargandoInfo: boolean = false;

  public tipo: string = '';
  public palabra: string = '';
  public idDashboard: string = '0';
  public nodoPadreEncontrado: ArbolDashboard[] = [];

  constructor(private router: Router, public sanitizer: DomSanitizer, private service: VisualizadorService, private route: ActivatedRoute, private location: Location) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state != undefined) {
      this.menuWeb = navigation?.extras.state!['objetos'];
    } else {
      this.menuWeb = undefined;
    }
    route.queryParams.subscribe({
      next: param => {
        this.idDashboard = param['idDashboard'];
      }
    })
  }

  hasChild = (_: number, node: ArbolDashboard) => !!node.hijos && node.hijos.length > 0;

  async ngOnInit(): Promise<void> {
    const currentUrl = this.location.path();
    this.service.generaTagsHtmlSEO('Tablas preconstruidas', 'Acceso a los reportes de las series con sus datos publicados.', 'Tablas preconstruidas, reportes, reporte', currentUrl);

    this.service.setWindowScroll(0, 0);
    this.tipo = this.route.snapshot.paramMap.get('tipo')!;
    this.palabra = this.route.snapshot.paramMap.get('palabra')!;

    this.cargandoInfo = true;

    var util: UtilidadDashboard = new UtilidadDashboard();
    var idSeries = '15270,65,1,15416'; //17500,17501,17502,17503
    var listaSerieOption: Array<SeriesOptionsType> = new Array();
    var titulo: string = '';
    var valorSerie = '';
    var subtitulo: string = '';
    var periodicidad: string = '';
    //this.service.getInformacionSerieXTipoDatoXFechaDesde(idSeries, 0, 20, 'year').subscribe({
    //this.service.getInformacionSerieXTipoDato(idSeriesDivision, 11, 12).subscribe({
    await this.service.getInformacionSerieXTipoDatoXFechaDesde(idSeries, 0, 35, 'year').subscribe({
      next: (jsonResponse) => {
        listaSerieOption.push(util.getSerieOptions(jsonResponse[0], 'line', '#003e6c'));
        titulo = jsonResponse[0].descripcion;
        periodicidad = jsonResponse[0].descripcionPeriodicidad;
        var valorSerie2 = formatNumber(Number(jsonResponse[0].valor), 'co-ES', '1.' + 2 + '-' + 2);
        subtitulo = valorSerie2 + jsonResponse[0].unidadCorta + ' <br> ' + jsonResponse[0].fecha;
        this.chartOptionsMetaInflacion = util.getChartTile(listaSerieOption, titulo, subtitulo, jsonResponse[0].unidadCorta, periodicidad);

        listaSerieOption = new Array();
        listaSerieOption.push(util.getSerieOptions(jsonResponse[1], 'area', '#999'));
        titulo = jsonResponse[1].descripcion;
        periodicidad = jsonResponse[1].descripcionPeriodicidad;

        valorSerie = formatNumber(Number(jsonResponse[1].valor), 'co-ES', '1.' + 2 + '-' + 2);
        subtitulo = valorSerie + jsonResponse[1].unidadCorta + ' <br> ' + jsonResponse[1].fecha;
        this.chartOptionsTPM = util.getChartTile(listaSerieOption, titulo, subtitulo, jsonResponse[1].unidadCorta, periodicidad);

        listaSerieOption = new Array();
        listaSerieOption.push(util.getSerieOptions(jsonResponse[2], 'area', '#999'));
        titulo = jsonResponse[2].descripcion;
        periodicidad = jsonResponse[2].descripcionPeriodicidad;

        valorSerie = formatNumber(Number(jsonResponse[2].valor), 'co-ES', '1.' + 2 + '-' + 2);
        subtitulo = valorSerie + jsonResponse[2].unidadCorta + ' <br> ' + jsonResponse[2].fecha;
        this.chartOptionsTRM = util.getChartTile(listaSerieOption, titulo, subtitulo, jsonResponse[2].unidadCorta, periodicidad);

        listaSerieOption = new Array();
        listaSerieOption.push(util.getSerieOptions(jsonResponse[3], 'area', '#aaa'));
        titulo = jsonResponse[3].descripcion;
        periodicidad = jsonResponse[3].descripcionPeriodicidad;
        valorSerie = formatNumber(Number(jsonResponse[3].valor), 'co-ES', '1.' + 0 + '-' + 0);
        subtitulo = valorSerie + jsonResponse[3].unidadCorta + ' <br> ' + jsonResponse[3].fecha;
        this.chartOptionsSalario = util.getChartTile(listaSerieOption, titulo, subtitulo, jsonResponse[3].unidadCorta, periodicidad);

        this.generaMenuCatalogoPrincipal();
        //this.cargandoInfo = false;
      },
      error: (error) => {
        console.log("Error inesperado en inflacion", error);
      }
    });
  }

  //GENERA EL MENU INICIAL
  private async generaMenuCatalogoPrincipal() {
    await this.service.getMenuXOpcion('DASHBOARD').subscribe({
      next: (listaCatalogoMenu) => {
        this.listaCatalogo = listaCatalogoMenu;
        this.listaTablaCatalogo = this.getTablaCatalogo(listaCatalogoMenu);
        let i = 0;
        this.listaTablaCatalogo.forEach(opcionCatalogo => {
          if (this.menuWeb != undefined && opcionCatalogo.id == this.getIdPadreRaiz(this.menuWeb.idPadre)) {
            this.selectedIndex = i;
          }
          var ma = this.generaArbol(opcionCatalogo.enlaces);
          this.mapaArbol.set(opcionCatalogo.titulo, ma);
          i++;
        });
        if (this.idDashboard && this.idDashboard !== '0') {
          //this.cargandoInfo = true;
          setTimeout(() => {
            this.accesoSeccion();
            for (let x of this.idDashboard.split(',')) {
              this.findAndExpandNode(Number(x));
            }
            this.cargandoInfo = false;
          }, 900);
        } else {
          this.cargandoInfo = false;
        }
      },
      error: (error) => {
        console.log("Error inesperado en getMenuXOpcion", error);
      }
    });
  }

  private generaArbol(listaMenuEstadistica: Array<MenuEstadistica>): Array<ArbolDashboard> {
    let result: Array<ArbolDashboard> = new Array();
    listaMenuEstadistica.forEach((element: MenuEstadistica) => {
      var estilo: string = '';
      if (element.id == 301) {
        estilo = 'mat-icon-rtl-mirror-red';
      } else if (element.id == 41004 || element.id == 302) {
        estilo = 'mat-icon-rtl-mirror-blue';
      }
      if (element.menuHijos && element.menuHijos.length > 0) {
        const children = this.generaArbol(element.menuHijos);
        result.push(this.convertToArbolDashboard(element.nombre, '', '', children));
      } else {
        if (element.listaMenuDashBoard && element.listaMenuDashBoard.length > 0) {
          let listaHijoDashboard: Array<ArbolDashboard> = new Array();
          element.listaMenuDashBoard.forEach(elementD => {
            listaHijoDashboard.push(this.convertToArbolDashboard(elementD.nombre, elementD.UrlDashboard, '', [], elementD.idDashBoard));
          });
          result.push(this.convertToArbolDashboard(element.nombre, '', estilo, listaHijoDashboard));
        } else {
          result.push(this.convertToArbolDashboard(element.nombre, '', '', []));
        }
      }
    });
    return result;
  }

  private convertToArbolDashboard(nombre: string, UrlDashboard: string, estilo: string, listaHijoDashboard: any, idDashBoard?: number): ArbolDashboard {
    let result: ArbolDashboard = {
      nombre: nombre,
      selected: false,
      estilo: estilo,
      url: UrlDashboard,
      hijos: listaHijoDashboard,
      idDashboard: idDashBoard
    };
    return result
  }

  private getTablaCatalogo(listaMenuEstadistica: Array<MenuEstadistica>): Array<TablaCatalogoDatos> {
    let listaResponse: Array<TablaCatalogoDatos> = new Array();
    let opcionCatalogo: TablaCatalogoDatos;
    listaMenuEstadistica.forEach(serieLista => {
      opcionCatalogo = new TablaCatalogoDatos();
      opcionCatalogo.titulo = serieLista.nombre;
      opcionCatalogo.id = serieLista.id;
      opcionCatalogo = this.utilidadTabla.getObjTablaCatalogo(serieLista.id * 1000, opcionCatalogo);
      opcionCatalogo = this.getSeccionChart(opcionCatalogo);
      if (serieLista.idPadre == 0) {
        let opcionEnlace: MenuEstadistica;
        let listaOpciones: Array<MenuEstadistica> = new Array();
        if (serieLista.menuHijos != undefined) {
          serieLista.menuHijos.forEach((serieHijo: MenuEstadistica) => {
            opcionEnlace = new MenuEstadistica();
            opcionEnlace = serieHijo;
            listaOpciones.push(opcionEnlace);
          });
        }
        opcionCatalogo.enlaces = listaOpciones;
      }
      listaResponse.push(opcionCatalogo);
    });
    this.utilidadTabla.ordenaTablaCatalogo(listaResponse);
    return listaResponse;
  }

  public cambiarSeccion(titulo: string) {
    var seccionTab = titulo;
    this.dataSource.data = this.mapaArbol.get(seccionTab)!;
  }

  private getIdPadreRaiz(id: number): number {
    let idString: string = id.toString();
    let idPadre: number = Number(idString.charAt(0)) * 1000;
    return idPadre;
  }

  /************************Highcharts**************************** */
  private getSeccionChart(tablaCatalogo: TablaCatalogoDatos): TablaCatalogoDatos {
    const id = tablaCatalogo.id;
    switch (id) {
      case 1:
        //		Precios e inflación 1000
        tablaCatalogo.highcharts = this.HighchartsMetaInflacion;
        tablaCatalogo.chartOptions = this.chartOptionsMetaInflacion;
        tablaCatalogo.tieneChart = true;
        break;
      case 2:
        //		Tasas de interés y sector financiero 2000
        tablaCatalogo.highcharts = this.HighchartsTPM;
        tablaCatalogo.chartOptions = this.chartOptionsTPM;
        tablaCatalogo.tieneChart = true;
        break;
      case 3:
        //		Operaciones del Banco en el mercado y Reservas internacionales 3000
        tablaCatalogo.highcharts = Highcharts;
        tablaCatalogo.chartOptions = {};
        tablaCatalogo.tieneChart = false;
        break;
      case 4:
        //		Tasas de cambio 4000
        tablaCatalogo.highcharts = this.HighchartsTRM;
        tablaCatalogo.chartOptions = this.chartOptionsTRM;
        tablaCatalogo.tieneChart = true;
        break;
      case 5:
        //		Actividad económica, mercado laboral y cuentas financieras 5000
        tablaCatalogo.highcharts = this.HighchartsSalario;
        tablaCatalogo.chartOptions = this.chartOptionsSalario;
        tablaCatalogo.tieneChart = true;
        break;
      case 6000:
        //		Sector público y deuda pública 6000
        tablaCatalogo.highcharts = Highcharts;
        tablaCatalogo.chartOptions = {};
        tablaCatalogo.tieneChart = false;
        break;
      default:
        tablaCatalogo.highcharts = Highcharts;
        tablaCatalogo.chartOptions = {};
        tablaCatalogo.tieneChart = false;
        break;
    }
    return tablaCatalogo;
  }

  public abrirEnlace(objeto: any, titulo: string) {
    var urlBase = environment.API_REST_SERVICE_URL;
    const url = objeto.url;
    if (this.contienePalabras(['2FTrabajo', '2FEstadisticas_Banco_de_la_Republica'], url)) {
      this.service.windowOpen(this.oracleReportDV + url, '_blank');
    } else if (url.includes('https:')) {
      this.service.getConsultaSerieArchivo(objeto.idDashboard).subscribe()
      this.service.windowOpen(url, '_blank');
    } else {
      this.service.windowOpen(urlBase + '/estadisticas-economicas-back/' + url, '_blank');
    }
  }

  private contienePalabras(palabras: string[], texto: string): boolean {
    return palabras.some(palabra => texto.includes(palabra));
  }

  public filtrar(palabra: string) {
    this.nodoPadreEncontrado = [];
    let resultado: ArbolDashboard | null = null;
    let nodePathTemp: ArbolDashboard[] = [];
    this.treeControl.collapseAll();
    for (let arbolCategoria of this.mapaArbol.values()) {
      let resultadoTemp = this.recursiveFindWord(arbolCategoria, palabra, nodePathTemp);
      if (!resultado)
        resultado = resultadoTemp
    }
    if (resultado) {
      this.filtroCategoria(nodePathTemp[0].nombre);
      this.nodoPadreEncontrado.push(nodePathTemp[nodePathTemp.length - 1]);
      for (let nodo of nodePathTemp) {
        this.treeControl.expand(nodo);
      }
      this.treeControl.expand(resultado);
    }
  }

  filtroCategoria(palabra: string) {
    this.accordionItem.forEach(accordion => accordion.close());
    const found = this.listaTablaCatalogo.find(item =>
      item.titulo.toLowerCase().includes(palabra.toLowerCase())
    );
    if (found) {
      this.expandCategory(found);
    } else {
      this.listaTablaCatalogo.some(element => {
        const listaArbolSeccion = this.mapaArbol.get(element.titulo)!;
        const resultado = this.filterItems(listaArbolSeccion, palabra);
        if (resultado != null && resultado.length > 0) {
          this.expandCategory(element);
          return true;
        } else {
          return false;
        }
      });
    }
  }

  filterItems(items: ArbolDashboard[], filterValue: string): ArbolDashboard[] {
    const resultado = items.filter(item => { return item.nombre?.toLowerCase().includes(filterValue.toLowerCase()) });
    if (resultado != null && resultado.length > 0) {
      return resultado;
    } else {
      return items
        .map(item => ({
          ...item,
          hijos: this.filterItems(item.hijos!, filterValue)
        }))
        .filter(item => item.nombre.toLowerCase().includes(filterValue) || item.hijos.length > 0);
    }
  }

  expandCategory(elemento: TablaCatalogoDatos) {
    this.cambiarSeccion(elemento?.titulo);
    const index = this.listaTablaCatalogo.indexOf(elemento);
    if (index !== -1) {
      const accordionOpen = this.accordionItem.toArray()[index];
      accordionOpen.open();
      document.querySelector("#accordion-header-" + index)!.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  findAndExpandNode(idDashboard: number) {
    let resultado: ArbolDashboard | null = null;
    let nodePathTemp: ArbolDashboard[] = [];
    for (let arbolCategoria of this.mapaArbol.values()) {
      let resultadoTemp = this.recursiveFind(arbolCategoria, idDashboard, nodePathTemp);
      if (!resultado)
        resultado = resultadoTemp
    }
    if (resultado) {
      this.filtroCategoria(nodePathTemp[0].nombre);
      this.nodoPadreEncontrado.push(nodePathTemp[nodePathTemp.length - 1]);
      for (let nodo of nodePathTemp) {
        this.treeControl.expand(nodo);
      }
      this.treeControl.expand(resultado);
    }
  }

  recursiveFind(mapaCateogria: ArbolDashboard[], idDashBoard: number, nodePathTemp: ArbolDashboard[]): ArbolDashboard | null {
    for (let nodo of mapaCateogria) {
      nodePathTemp.push(nodo);
      if (nodo.idDashboard === idDashBoard) {
        return nodo;
      } else if (nodo.hijos && nodo.hijos.length > 0) {
        for (let nodoHijo of nodo.hijos) {
          if (idDashBoard === nodoHijo.idDashboard) {
            return nodo;
          }
        }
        let resultado = this.recursiveFind(nodo.hijos, idDashBoard, nodePathTemp);
        if (resultado != null) {
          return resultado;
        }
      }
      nodePathTemp.pop();
    }
    nodePathTemp = [];
    return null;
  }

  private accesoSeccion() {
    if (this.tipo && 'consulta' === this.tipo) {
      this.filtrar(this.palabra);
    }
  }

  recursiveFindWord(mapaCateogria: ArbolDashboard[], palabra: string, nodePathTemp: ArbolDashboard[]): ArbolDashboard | null {
    for (let nodo of mapaCateogria) {
      nodePathTemp.push(nodo);
      if (this.buscarPalabra(nodo.nombre, palabra)) {
        return nodo;
      } else if (nodo.hijos && nodo.hijos.length > 0) {
        let resultado = this.recursiveFindWord(nodo.hijos, palabra, nodePathTemp);
        if (resultado != null) {
          return resultado;
        }
      }
      nodePathTemp.pop();
    }
    nodePathTemp = [];
    return null;
  }

  private buscarPalabra(texto: string, palabra: string): boolean {
    // Función para normalizar texto: quitar tildes y pasar a minúsculas
    const normalizar = (str: string) =>
      str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    const textoNormalizado = normalizar(texto);
    const palabraNormalizada = normalizar(palabra);

    // Buscar la palabra como palabra completa
    return textoNormalizado.includes(palabraNormalizada);
  }
}